import React from 'react';
import { Tabs } from 'antd';

// 上午 / 下午固定時段 (可放在這)
const fixedMorningSlots = [
  { value: '08:30', disabled: true },
  { value: '09:00', disabled: false },
  { value: '09:30', disabled: false },
  { value: '10:00', disabled: false },
  { value: '10:30', disabled: false },
  { value: '11:00', disabled: false },
  { value: '11:30', disabled: false },
  { value: '12:00', disabled: true },
];

const fixedAfternoonSlots = [
  { value: '13:00', disabled: false },
  { value: '13:30', disabled: false },
  { value: '14:00', disabled: true },
  { value: '14:30', disabled: false },
  { value: '15:00', disabled: false },
  { value: '15:30', disabled: false },
  { value: '16:00', disabled: true },
];

// 獨立的渲染函式
function renderTimeSlots(slots, selectedTime, onTimeSelect) {
  return (
    <div className="time-slots-grid">
      {slots.map((slot) => (
        <div
          key={slot.value}
          className={`time-slot-button ${
            slot.disabled
              ? 'disabled'
              : selectedTime === slot.value
              ? 'selected'
              : ''
          }`}
          onClick={() => {
            if (!slot.disabled) {
              onTimeSelect(slot.value);
            }
          }}>
          {slot.value}
        </div>
      ))}
    </div>
  );
}

const TimeSlotSelector = ({
  availableTimeList, // 當日可預約的時段清單
  selectedPeriod, // 'morning' or 'afternoon'
  onPeriodChange, // 函式：Tab切換時
  selectedTime, // 目前選到的時段
  onTimeSelect, // 函式：點擊某時段時
}) => {
  const availableTimesSet = new Set(availableTimeList);
  const availableMorningSlots = fixedMorningSlots.map((slot) => ({
    ...slot,
    disabled: !availableTimesSet.has(slot.value),
  }));
  const availableAfternoonSlots = fixedAfternoonSlots.map((slot) => ({
    ...slot,
    disabled: !availableTimesSet.has(slot.value),
  }));

  return (
    <div className="time-slot-selector">
      <Tabs
        activeKey={selectedPeriod}
        onChange={onPeriodChange}
        items={[
          {
            key: 'morning',
            label: '上午',
            children: renderTimeSlots(
              availableMorningSlots,
              selectedTime,
              onTimeSelect
            ),
          },
          {
            key: 'afternoon',
            label: '下午',
            children: renderTimeSlots(
              availableAfternoonSlots,
              selectedTime,
              onTimeSelect
            ),
          },
        ]}
      />
    </div>
  );
};

export default TimeSlotSelector;
